function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".barcode-ico{opacity:0.8;}.barcode-item-ico{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "barcode-ico"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M4.5,2H2A2,2,0,0,0,0,4V6.5a.5.5,0,0,0,1,0V4A1,1,0,0,1,2,3H4.5a.5.5,0,0,0,0-1Z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M20,6.5V4a2,2,0,0,0-2-2H15.5a.5.5,0,0,0,0,1H18a1,1,0,0,1,1,1V6.5a.5.5,0,0,0,1,0Z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5,18H18a2,2,0,0,0,2-2V13.5a.5.5,0,0,0-1,0V16a1,1,0,0,1-1,1H15.5a.5.5,0,0,0,0,1Z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M0,13.5V16a2,2,0,0,0,2,2H4.5a.5.5,0,0,0,0-1H2a1,1,0,0,1-1-1V13.5a.5.5,0,0,0-1,0Z"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: 1,
  height: 10,
  rx: 0.5,
  transform: "translate(3 5)"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: 2,
  height: 10,
  rx: 0.5,
  transform: "translate(5 5)"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: 1,
  height: 10,
  rx: 0.5,
  transform: "translate(8 5)"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: 2,
  height: 10,
  rx: 0.5,
  transform: "translate(10 5)"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: 1,
  height: 10,
  rx: 0.5,
  transform: "translate(16 5)"
}),
/*#__PURE__*/
React.createElement("rect", {
  width: 2,
  height: 10,
  rx: 0.5,
  transform: "translate(13 5)"
}),
/*#__PURE__*/
React.createElement("rect", {
  className: "barcode-item-ico",
  width: 20,
  height: 20
}));

var SvgBarcodeScanner = function SvgBarcodeScanner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgBarcodeScanner, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/BarcodeScanner.5869d113.svg";
export { ForwardRef as ReactComponent };